import { useState } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import loadingGif from '../../assets/images/loading.gif';
import GlobalStyle from '../../globalStyle';
import { NavHeightContext } from '../Context/NavHeightContext';

import * as S from './App.styles';
import FlyingSenglar from './FlyingSenglar';
import Footer from './Footer';
import Header from './Header';

const link = document.createElement('link');
link.rel = 'preload';
link.href = loadingGif;
link.as = 'image';
document.head.appendChild(link);

const App = () => {
	const location = useLocation();
	const [navHeight, setNavHeight] = useState(0);

	return (
		<NavHeightContext.Provider value={{ navHeight, setNavHeight }}>
			<GlobalStyle />
			<ScrollRestoration />
			<S.AppContainer>
				<FlyingSenglar />
				<Header />
				<S.PreContentBox />
				<S.ContentContainer $path={location.pathname} $navHeight={navHeight}>
					<Outlet />
				</S.ContentContainer>
				<Footer />
			</S.AppContainer>
		</NavHeightContext.Provider>
	);
};

export default App;
